/* schmorzeit.js - Verhalten der Schmorzeit-Kampagnenseite.
   Vanilla, kein Build, kein Framework. Alles haengt an data-Attributen, damit
   die Sections im Theme-Editor frei sortierbar bleiben.
   Warenkorb laeuft ueber /cart/add.js und den bestehenden Cart-Drawer. */
(function () {
  'use strict';
  // Jede Section bindet die Datei ein, ausgefuehrt werden soll sie nur einmal
  if (window.__schmorzeit) return;
  window.__schmorzeit = true;

  /* ---- Hilfen ------------------------------------------------------ */
  function euro(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function config() {
    var el = document.querySelector('[data-sz-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function saleOn(cfg) {
    if (!cfg || !cfg.saleActive) return false;
    var end = Date.parse(cfg.saleEnd || '');
    return !(end && Date.now() > end);
  }

  function meldung(text, art) {
    var alt = document.querySelector('[data-sz-toast]');
    if (alt) alt.remove();
    var box = document.createElement('div');
    box.className = 'sz-toast' + (art === 'fehler' ? ' sz-toast--fehler' : '');
    box.setAttribute('role', art === 'fehler' ? 'alert' : 'status');
    box.setAttribute('data-sz-toast', '');
    box.textContent = text;
    document.body.appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-visible'); });
    setTimeout(function () {
      box.classList.remove('is-visible');
      setTimeout(function () { box.remove(); }, 300);
    }, 5000);
  }

  function addToCart(items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        // Shopify meldet z. B. zu wenig Bestand mit 422 und einer lesbaren Beschreibung
        if (!r.ok) throw new Error(data && (data.description || data.message) || 'Fehler ' + r.status);
        return data;
      });
    });
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }

  /* ---- Raster: mehr zeigen ----------------------------------------- */
  function initMore(root) {
    root.querySelectorAll('[data-sz-more-btn]').forEach(function (btn) {
      if (btn.dataset.szBound) return;
      btn.dataset.szBound = '1';
      btn.addEventListener('click', function () {
        var section = btn.closest('[data-sz-products]');
        var rest = section.querySelectorAll('[data-sz-more]');
        rest.forEach(function (el) { el.hidden = false; });
        btn.remove();
        // Fokus auf die erste neue Karte, damit Tastaturnutzer dort weiterlesen
        var link = rest[0] && rest[0].querySelector('a[href]');
        if (link) link.focus();
      });
    });
  }

  /* ---- Schiene ----------------------------------------------------- */
  function initRails(root) {
    root.querySelectorAll('[data-sz-rail]').forEach(function (section) {
      if (section.dataset.szBound) return;
      section.dataset.szBound = '1';
      var track = section.querySelector('[data-sz-rail-track]');
      var prev = section.querySelector('[data-sz-rail-prev]');
      var next = section.querySelector('[data-sz-rail-next]');
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.sz-rail__item');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        var w = item ? item.getBoundingClientRect().width + gap : 250;
        return Math.max(w, Math.floor(track.clientWidth / w) * w);
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---- Pakete ------------------------------------------------------ */
  function initPakete(root) {
    var cfg = config();
    var on = saleOn(cfg);

    root.querySelectorAll('[data-sz-paket]').forEach(function (card) {
      var btn = card.querySelector('[data-sz-paket-add]');
      if (!btn) return;
      var sum = Number(btn.dataset.szSum) || 0;
      var reduced = Number(btn.dataset.szReduced) || 0;
      var tierEl = card.querySelector('[data-sz-paket-tier]');
      var wasEl = card.querySelector('[data-sz-paket-was]');
      var netEl = card.querySelector('[data-sz-paket-net]');
      var giftEl = card.querySelector('[data-sz-paket-gift]');

      // Rabatt nur waehrend des Sales. Stufe nach Warenwert vor Rabatt, wie im Warenkorb.
      tierEl.hidden = true;
      wasEl.hidden = true;
      giftEl.hidden = true;
      netEl.textContent = euro(sum);
      if (on && sum > 0) {
        var pct = 0;
        (cfg.tiers || []).forEach(function (t) {
          if (t.pct > 0 && sum >= t.from * 100 && t.pct > pct) pct = t.pct;
        });
        if (pct > 0) {
          var base = cfg.excludeReduced ? sum - reduced : sum;
          // Shopify rundet den Rabatt auf den Cent ab, also hier genauso
          var net = sum - Math.floor(base * pct / 100 + 1e-9);
          tierEl.textContent = '−' + pct + ' %';
          tierEl.hidden = false;
          wasEl.textContent = euro(sum);
          wasEl.hidden = false;
          netEl.textContent = euro(net);
        }
        if (cfg.giftsActive) {
          var gifts = (cfg.gifts || []).filter(function (g) { return g.name && g.from > 0; });
          var reached = gifts.filter(function (g) { return sum >= g.from * 100; });
          if (reached.length === 0 && gifts.length) {
            giftEl.textContent = 'Noch ' + euro(gifts[0].from * 100 - sum) + ' bis zur ersten Gratis-Dose (mit Newsletter)';
            giftEl.classList.remove('is-reached');
          } else if (reached.length === 1) {
            giftEl.textContent = 'Mit Newsletter: 1 Dose nach Wahl gratis dazu';
            giftEl.classList.add('is-reached');
          } else if (reached.length > 1) {
            giftEl.textContent = 'Mit Newsletter: ' + reached.length + ' Dosen nach Wahl gratis dazu';
            giftEl.classList.add('is-reached');
          }
          giftEl.hidden = gifts.length === 0;
        }
      }

      if (btn.dataset.szBound) return;
      btn.dataset.szBound = '1';
      btn.addEventListener('click', function () {
        var items = (btn.dataset.szPaketAdd || '').split(',').filter(Boolean).map(function (pair) {
          var p = pair.split(':');
          return { id: Number(p[0]), quantity: Number(p[1]) || 1 };
        });
        if (!items.length || btn.disabled) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt …';
        addToCart(items)
          .then(function () {
            btn.classList.add('is-done');
            btn.textContent = 'Liegt im Warenkorb';
            openCartDrawer();
            setTimeout(function () {
              btn.classList.remove('is-done');
              btn.textContent = label;
              btn.disabled = false;
            }, 2400);
          })
          .catch(function (err) {
            btn.textContent = label;
            btn.disabled = false;
            meldung(err.message || 'Das Paket konnte nicht in den Warenkorb. Bitte versuch es noch einmal.', 'fehler');
          });
      });
    });
  }

  /* ---- Paket-Slider: Punkte zeigen das sichtbare Paket ------------- */
  function initPaketDots(root) {
    root.querySelectorAll('[data-sz-paket-track]').forEach(function (track) {
      if (track.dataset.szDots) return;
      track.dataset.szDots = '1';
      var dots = track.parentElement.querySelectorAll('[data-sz-paket-dots] span');
      if (!dots.length) return;
      function update() {
        var cards = track.querySelectorAll('[data-sz-paket]');
        var left = track.getBoundingClientRect().left;
        var best = 0, dist = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.getBoundingClientRect().left - left);
          if (d < dist) { dist = d; best = i; }
        });
        // Am rechten Ende gilt das letzte Paket als aktiv
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === best); });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    });
  }

  /* ---- Klaviyo-Formular per Link oeffnen --------------------------- */
  function initKlaviyo(root) {
    root.querySelectorAll('[data-sz-klaviyo]').forEach(function (a) {
      if (a.dataset.szBound) return;
      a.dataset.szBound = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', a.dataset.szKlaviyo]);
      });
    });
  }

  function init(root) {
    root = root || document;
    initMore(root);
    initRails(root);
    initPakete(root);
    initPaketDots(root);
    initKlaviyo(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme-Editor: neu geladene Sections wieder verdrahten
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
